<template>
    <span class="badge-delete" v-if="isDeleted">Deleted</span>
</template>

<script>
export default {
	name: 'BadgeDeleted',
	props: {
		isDeleted: {
			type: Boolean,
			default: false,
		},
	},
};
</script>

<style scoped>
.badge-delete {
	font-size: 10px;
	font-weight: 600;
	background-color: red;
	color: white;
	padding-left: 0.5rem !important;
	padding-right: 0.5rem !important;
	clip-path: polygon(0 0, 100% 0, 90% 50%, 100% 100%, 0 100%, 10% 50%);
}
</style>
